<div class="c-adventureQuest__rewardBox">
  @if (eventChallengeProgressive) {
    <div
      class="c-adventureQuest__rewardBox__background"
      [ngClass]="{ 'c-adventureQuest__rewardBox__background--redeemed': eventChallengeProgressive.redeemed }"
      theming
      themingGroup="adventurequest"
      [themingAsset]="
        event.current < eventChallengeProgressive.position || eventChallengeProgressive.redeemed
          ? 'milestone-inactive'
          : 'milestone-active'
      "
      [themingOverride]="event?.assets">
      <div class="c-adventureQuest__rewardBox_container">
        <div class="c-adventureQuest__rewardBox_lock">
          @if (!eventChallengeProgressive.redeemed) {
            <div
              class="e-locker"
              theming
              themingGroup="adventurequest"
              [themingAsset]="event.current < eventChallengeProgressive.position ? 'locked' : 'unlocked'"
              [themingOverride]="event?.assets"></div>
          }
        </div>
        <div
          class="e-treasure"
          theming
          themingGroup="adventurequest"
          [themingAsset]="rewardAssetSize"
          [themingOverride]="event?.assets">
          <slotcom-display [classes]="['c-display--gameChallenges']">
            <div
              displayIcon
              displayIconPos="left"
              class="c-display--coin"></div>
            <span class="text reward">{{
              eventChallengeProgressive.reward?.credits | beautifyNumber: ('common.culture' | translate)
            }}</span>
          </slotcom-display>
        </div>
        @if (event.current >= eventChallengeProgressive.position && !eventChallengeProgressive.redeemed) {
          <slotcom-button
            class="c-button--pink"
            (safeClick)="collectRewardOutput()"
            [isLoading]="isLoading"
            audioType="reward">
            {{ 'common.collect' | translate | uppercase }}
          </slotcom-button>
        }
      </div>
    </div>
    @if (eventChallengeProgressive.redeemed) {
      <div class="e-check"></div>
    }
  }
</div>
